import React, { FC } from "react";
import RoleCard from "../atoms/RoleCard";
import AgentCard from "../atoms/AgentCard";
import FlowCard from "../atoms/FlowCard";



interface Flow{
    id:number;
    name:string;
    updatedOn: string;
    description:string;
    createdBy: string;
    agents:number
  }

interface FLowListProps {
  flows: Flow[];
  crewName:string
  crewId:number
  onDelete: (id: number) => void; 
}

const FlowList: FC<FLowListProps> = ({ flows ,onDelete, crewName,crewId}) => {
  return (
    <>
      <ul className="p-0" style={{listStyle:'none'}}>
      {flows.map((flow) => (
        <div key={flow.id}>
        <FlowCard flow={flow} onDelete={onDelete} crewName = {crewName} crewId = {crewId}/>
        </div>
      ))}
      </ul>
    </>
  );
};

export default FlowList;
